import request from './request';
import { createStorage, setStorage, STORAGE_KEYS } from './storage';

export type ActiveConfig = {
  domains: string[];
  cdn?: string;
  home_page_cdn?: string;
  inner_country?: boolean;
  ip: string;
  ip_city: string;
  ip_country: string;
  isp: string;
};

const defaultActiveConfig: ActiveConfig = {
  domains: [],
  home_page_cdn: '',
  inner_country: false,
  ip: '',
  ip_city: '',
  ip_country: '',
  isp: '',
};

const activeConfigStorage = createStorage(STORAGE_KEYS.ACTIVE_CONFIG, defaultActiveConfig);

export async function fetchActiveConfig(): Promise<ActiveConfig> {
  try {
    const { data } = await request.get('/bff/material/c/push/active.json');
    const nextConfig: ActiveConfig = {
      domains: data?.domains || [],
      cdn: data?.cdn || '',
      home_page_cdn: data?.home_page_cdn || '',
      inner_country: data?.inner_country,
      ip: data?.ip || '',
      ip_city: data?.ip_city || '',
      ip_country: data?.ip_country || '',
      isp: data?.isp || '',
    };
    setStorage(STORAGE_KEYS.ACTIVE_CONFIG, nextConfig);
    return nextConfig;
  } catch (error) {
    console.log('[ActiveConfig] Failed to fetch active config', error);
    return activeConfigStorage ?? defaultActiveConfig;
  }
}

export async function initActiveConfig() {
  await fetchActiveConfig();
}
